import lazyLoadOnRender from '../../lazy/loadOnRender';

const VivaEngageNavigationHeaderMoreActions = () =>
  import(
    /* webpackChunkName: "4-feat-vivaengagenavigationheadermoreactions" */ './VivaEngageNavigationHeaderMoreActions'
  );

export default lazyLoadOnRender({ loader: VivaEngageNavigationHeaderMoreActions });
